import { User } from "../models/User/User";
import { postIdentityAPI } from "./identityHttp";

export type SendOtpRequest = {
  email?: string;
  phone?: string;
  countryCode?: string;
};

export type LoginOtpRequest = {
  email?: string;
  phone?: string;
  countryCode?: string;
  otp: string;
};

export interface IdentitySessionResult {
  id: number;
  name: string;
  email: string;
  accessLevel: string | number;
  phone_number?: string;
  calling_code?: string;
  image_url?: string | null;
  access_level_label?: string;
  token: string;
  authToken?: string;
  refreshToken?: string;
  expiresIn?: number;
}

const compactBody = (body: Record<string, unknown>): Record<string, unknown> => {
  const next: Record<string, unknown> = {};
  Object.entries(body).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      next[key] = value;
    }
  });
  return next;
};

export const mapIdentitySessionToUser = (
  result: IdentitySessionResult,
): User => {
  return {
    id: result.id,
    name: result.name,
    email: result.email,
    accessLevel: String(result.accessLevel ?? ""),
    otp: "",
    token: result.authToken || result.token,
    phone_number: result.phone_number,
    image_url: result.image_url ?? undefined,
    access_level_label: result.access_level_label,
    calling_Code: result.calling_code,
  };
};

export default class IdentityAPI {
  sendOtp = async (request: SendOtpRequest): Promise<void> => {
    try {
      await postIdentityAPI(
        "/send-otp",
        compactBody({
          email: request.email,
          phone: request.phone,
          countryCode: request.countryCode,
        }),
      );
    } catch (error) {
      throw error;
    }
  };

  loginOtp = async (request: LoginOtpRequest): Promise<IdentitySessionResult> => {
    try {
      const response = await postIdentityAPI(
        "/login/otp",
        compactBody({
          email: request.email,
          phone: request.phone,
          countryCode: request.countryCode,
          otp: request.otp,
        }),
      );
      return response.result as IdentitySessionResult;
    } catch (error) {
      throw error;
    }
  };
}
